import { searchObjectList } from './utils';
import { t } from './i18n';

const placeholderTypes = [
    {
        value: 'SIMPLE',
        name: t('placeholderTypeSimple'),
        enabled: true,
    },
    {
        value: 'MULTIPLE',
        name: t('placeholderTypeMultiple'),
        enabled: true,
    },
    {
        value: 'IMAGECODE',
        name: t('placeholderTypeImageCode'),
        enabled: true,
    },
];

export const createVariableMarkup = (group, name) => {
    return `[=${group}[0].${name}]`;
};

export const createIteratorVariableMarkup = (group, name) => {
    return `[=item.${name}]`;
};

const iteratorMapping = {
    table: {
        header: '<th>%value%</th>',
        body: '<td>[=item.%value%]</td>',
    },
    blocks: {
        header: '<div class="template-grid-header">%value%</div>',
        body: '<div class="template-grid-value">%value%</div>',
    },
    form: {
        header: '<th>%value%</th>',
        body: '<td>[=item.%value%]</td>',
    },
};

// Helpers
const composeIteratorRowMarkup = (model, template, key) => {
    const cells = [];
    model.map((cell) => {
        cells.push(`${template.replace('%value%', cell[key])}`);
    });
    return cells.join('');
};

export const createIteratorMarkup = (group, model) => {
    const markupHeader = [];
    const markupBody = [];

    const headerRow = composeIteratorRowMarkup(model, iteratorMapping.table.header, 'name');
    markupHeader.push(`<tr class="iterator-header">${headerRow}</tr>`);
    const valueRow = composeIteratorRowMarkup(model, iteratorMapping.table.body, 'key');
    markupBody.push(`<tr class="iterator-body">${valueRow}</tr>`);

    return `<table class="iterator-table">
    <tbody>
        ${markupHeader.join('')}
        ${markupBody.join('')}
    </tbody>
</table>`;
};

const conditionMapping = {
    initial: {
        IF: '#if',
    },
    logical: {
        AND: '&&',
        OR: '||',
    },
    relational: {
        contains: '?contains',
        exists: '??',
        'length ==': '?length ==',
        'length !=': '?length !=',
        'length >=': '?length gt=',
        'length <=': '?length lt=',
        'length >': '?length gt',
        'length <': '?length lt',
        '==': '==',
        '!=': '!=',
        //'>=': '&gt;=',
        //'<=': '&lt;=',
        //'>': '&gt;',
        //'<': '&lt;',
    },
};

export const getConditionLogicals = (index) => {
    return Number(index) === 0 ? conditionMapping.initial : conditionMapping.logical;
};

export const getConditionRelationals = () => {
    return conditionMapping.relational;
};

// Helpers
const composeConditionValuesMarkup = (condition) => {
    const wrap = [];
    condition.values.map((value) => {
        const realOperator = getConditionRelationals()[value.operator];
        const realVariableFormat = condition.type === 'MULTIPLE' ? 'item' : `${condition.group}[0]`;

        if (value.operator === 'exists') {
            wrap.push(`${realVariableFormat}.${condition.name}${realOperator}`);
        }

        if (value.operator === 'contains') {
            wrap.push(`${realVariableFormat}.${condition.name}${realOperator}("${value.value}")`);
        }

        if (value.operator.startsWith('length')) {
            wrap.push(`${realVariableFormat}.${condition.name}${realOperator} ${value.value}`);
        }

        if (/==|!=/.test(value.operator)) {
            wrap.push(`${realVariableFormat}.${condition.name} ${realOperator} "${value.value}"`);
        }
    });

    const glue = getConditionLogicals(1)[condition.glue];
    return wrap.join(` ${glue} `);
};

export const createConditionMarkup = (conditions, useElse = false) => {
    const template = {
        conditions: [],
        body: ' TEXT ',
        elseBody: ' FINALLY ',
    };

    template.conditions.push('[');

    for (let index in conditions) {
        const condition = conditions[index];
        const parts = composeConditionValuesMarkup(condition);
        template.conditions.push(`${getConditionLogicals(index)[condition.logical]}`);
        template.conditions.push(
            condition.values.length > 1 && conditions.length > 1 ? ` ( ${parts} ) ` : ` ${parts} `,
        );
    }
    template.conditions.push(']');
    template.conditions.push(template.body);
    if (useElse === true) {
        template.conditions.push('[#else]');
        template.conditions.push(template.elseBody);
    }
    template.conditions.push('[/#if]');
    return template.conditions;
};

export const extractRealDescription = (placeholderGroup, variable) => {
    const uicp = JSON.parse(placeholderGroup.uiConfig);
    return uicp !== null && Object.keys(uicp).includes(variable) && uicp[variable].length > 0
        ? uicp[variable]
        : variable;
};

export const getPlaceholderTypes = () => {
    return placeholderTypes;
};

export const getPLaceholderType = (model) => {
    return searchObjectList(placeholderTypes, 'value', model.type)['name'];
};

export const isSimpleType = (model) => {
    return placeholderTypes[0].value === model.type;
};

export const isMultipleType = (model) => {
    return placeholderTypes[1].value === model.type;
};

export const isImageType = (model) => {
    return placeholderTypes[2].value === model.type;
};

export const usePlaceholderTypes = () => {
    return {
        createVariableMarkup: createVariableMarkup,
        createIteratorVariableMarkup: createIteratorVariableMarkup,
        createConditionMarkup: createConditionMarkup,
        createIteratorMarkup: createIteratorMarkup,
        getConditionLogicals: getConditionLogicals,
        getConditionRelationals: getConditionRelationals,
        extractRealDescription: extractRealDescription,
        getPlaceholderTypes: getPlaceholderTypes,
        getPLaceholderType: getPLaceholderType,
        isSimpleType: isSimpleType,
        isMultipleType: isMultipleType,
        isImageType: isImageType,
    };
};

export default usePlaceholderTypes;
